import { 
  loadRecommendationsEvents,
  loadRecommendationsPlaces, 
  loadRecommendationsRoutes 
} from '@common/redux/slices/recommendation.slice';
import { reduxWrapper } from '@common/redux/store';
import { Overviews } from '@kursk/components/pages/Overviews/Overviews';
import { loadEntitiesFromQuery } from '@kursk/utils/loadEntitiesFromQuery';
import React from 'react';

export default function OverviewsPage() {
  return <Overviews />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query }) => {
  await Promise.all([
    loadEntitiesFromQuery('overviews', query, store),
    store.dispatch(loadRecommendationsEvents({ locales: query.locales })),
    store.dispatch(loadRecommendationsRoutes({})),
    store.dispatch(loadRecommendationsPlaces({ locales: query.locales })),
  ]);
  
  return { props: {} };
})